import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { spotBidExpireTimeApiSchema } from '../../models';

const shipmentApi = fetcher.extend(() => ({ prefixUrl: `${API.SHIPMENT}` }));

export type GetSpotBidExpirationTimeRequestParams = {
  CustomerKey: number;
};

export const fetchSpotBidExpirationTimeOptions = async (
  filters: GetSpotBidExpirationTimeRequestParams,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await shipmentApi
      .get('GetSpotBidExpirationTime', { searchParams: filters, signal })
      .json(spotBidExpireTimeApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn(
        'Validation error on GetSpotBidExpirationTime response',
        (error as ValiError<typeof spotBidExpireTimeApiSchema>).issues,
      );
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
